import React, { Component } from 'react';
import diversity from './data/Diversity.json';
import { Row, Col } from 'react-bootstrap';
import TitlewContent from './components/TitlewContent';
import $, { data } from "jquery";

class Responsibility extends Component {
	constructor(props) {
		super(props);
		// this.eachPartner = this.eachPartner.bind(this);
		// this.state = {
		// 	title: div,
		// 	subtitle: "",
		// 	mainImage: [],
		// 	overview: "",
		// 	partnerships: [],

		// }
	}

	// componentDidMount() {
	// 	let self = this;
	// 	$.get('https://apipr.crownmediadev.com/api/content?siteid=3112&nodeid=3105&areaid=2', function (data) {
	// 		data = data.sort(function (a, b) { return a.Sort - b.Sort });
	// 		let partnerArr = data.slice(1);
	// 		self.setState(
	// 			{
	// 				title: data[0].MovieName,
	// 				subtitle: data[0].subTitle,
	// 				mainImage: data[0].ImagePath,
	// 				overview: data[0].ShortSynopsis,
	// 				partnerships: partnerArr
	// 			}
	// 		);
	// 	});
	// }

	// eachPartner(partner, i) {
	// 	return (
	// 		<TitlewContent key={i + 50} data={partner} />
	// 	)
	// }


	render() {
		let partnershipsList = diversity.partnerships.map(item => {
			return (
				<TitlewContent key={item + 50} data={item} />
			)
		});


		let celebratesList = diversity.hallmarkMediaCelebrates.map(item => {
			return (
				<Col  xs={12} md={12} className='celebrates-items items' key={item.id}>
					<div className='title'>{item.GroupName}</div>
					<div className='group-logo'><img className='celebrates-img' alt='celebrates logo' src={item.ImagePath} /></div>
				</Col>
			)
		})


		return (
			<div className="diversity-full-page">
				<div className='diversity-img-background'>
					<div className="container">
						<div className="row show-grid">
							<div className="col-xs-12 col-md-12">
								<img className="pageBannerImg" alt="Hallmark Media Diversity & Inclusion" src='/images/CC24_HM_CorpWeb_Banner_DiversityAndInclusion_1440x560_v1.jpg' />
							</div>
						</div>
					</div>
				</div>
				<div className='diversity-outer-container'>
					<div className="container">
						<div className="row show-grid">
							<div className="col-xs-12 col-md-12">
								<Row className="show-grid">
									<Col xs={12} md={12}>
										<h2 className="">DIVERSITY & INCLUSION</h2>
										<hr />
										<p className="about-us-p">At Hallmark Media, we embrace diversity and inclusion as an integral part of our corporate culture. We’re committed to maintaining an open, respectful environment that celebrates inclusion and empowers all employees to share their ideas and make meaningful contributions to the company’s success. Our mission to cultivate a workplace that represents a range of cultural backgrounds, ethnicities, and voices is central to our values and essential to our company’s strength, innovation, and creative excellence.</p>
									</Col>
								</Row>
							</div>
						</div>
					</div>
				</div>
				<div className="container">
					<div className="row show-grid">
						<div className="col-xs-12 col-md-12">
							<h2>PARTNERSHIPS</h2>
							<hr />
							{partnershipsList}

						</div>
					</div>
				</div>
				<div className="container">
					<div className="row show-grid">
						<div className="col-xs-12 col-md-12">
							<h2>EMPLOYEE RESOURCE COUNCIL</h2>
							<hr />
							<Row className="resource-container diversity-container" >
								<Col  xs={12} md={12} className="resource-items items">
									<div className='group-logo'><img className='group-img' alt='resource group image' src='/images/ERC Logo.jpg' /></div>
									<div className='group-desc'>The <strong>Employee Resource Council</strong> is committed to building a workplace that is predicated on Inclusion and Equality at Hallmark Media, a vital component for sustained growth and success for our business.</div>
								</Col>
							</Row>
						</div>
					</div>
				</div>
				<div className="container">
					<div className="row show-grid">
						<div className="col-xs-12 col-md-12">
							<h2>HALLMARK MEDIA CELEBRATES</h2>
							<hr />
							<div className='subtext'>Hallmark Media celebrates many local and nationwide initiatives in the effort to spread awareness and commemorate the past, present, and future of the individuals that make up our workforce.</div>
							<Row className="celebrates-container diversity-container" >
								{celebratesList}
							</Row>
						</div>
					</div>
				</div>
				
			</div>
		);
	}

}

export default Responsibility;